import { render, staticRenderFns } from "./ButtonSmall.vue?vue&type=template&id=74e6e069&scoped=true"
import script from "./ButtonSmall.vue?vue&type=script&lang=js"
export * from "./ButtonSmall.vue?vue&type=script&lang=js"
import style0 from "./ButtonSmall.vue?vue&type=style&index=0&id=74e6e069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e6e069",
  null
  
)

export default component.exports